import { render, staticRenderFns } from "./BackendTable.vue?vue&type=template&id=1e6e353a"
import script from "./BackendTable.vue?vue&type=script&lang=js"
export * from "./BackendTable.vue?vue&type=script&lang=js"
import style0 from "./BackendTable.vue?vue&type=style&index=0&id=1e6e353a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports